export default __webpack_public_path__ + "img/course-brunch.758c9b055225ba61e8c9b5374c88bd5f.png";